import HTTP from "../../utility/http";
import { asyncHandler } from "@/utility/async";
const clone = require("lodash/cloneDeep");

const state = {
  rivers: [],
};

const getters = {
  getRivers: (state) => state.rivers,
};

const actions = {
  async all({ commit }, data) {
    const resp = await asyncHandler(
      HTTP({ url: "river/all/" + data.withDeleted, method: "GET" })
    );
    if (resp.success) {
      commit("set_rivers", resp.rivers);
    }
    return resp;
  },

  async reload({ commit }, data) {
    const resp = await asyncHandler(
      HTTP({ url: "river/all/" + data.withDeleted, method: "GET" })
    );
    if (resp.success) {
      commit("set_rivers", resp.rivers);
    }
    return resp;
  },

  async save_river(context, d) {
    let data = clone(d);
    data.fee = data.fee * 100;
    const url = data.id ? "river/" + data.id : "river";
    const method = data.id ? "PUT" : "POST";
    return await asyncHandler(HTTP({ url, method, data }));
  },

  async delete_river(context, data) {
    return await asyncHandler(
      HTTP({ url: "river/" + data.id, method: "DELETE" })
    );
  },

  async restore_river(context, data) {
    return await asyncHandler(
      HTTP({ url: "river/restore/" + data.id, method: "GET" })
    );
  },
};

const mutations = {
  set_rivers: (state, rivers) => {
    state.rivers = rivers;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
